import { type DeliveryAddressesResponse } from '@Src/types/deliveryAddressTypes';
import { logger } from '@Src/utility/loggerService';
import Cookies from 'js-cookie';

const baseUrl = 'https://api.flipdish.co';

const getDeliveryAddresses = async (
  appId: string,
  deviceId: string,
  lang: string,
  version?: string,
): Promise<DeliveryAddressesResponse> => {
  try {
    const headers = {
      'Content-Type': 'application/json',
      'Flipdish-App-Type': 'Web',
      'Flipdish-App-Version': version || '',
      'Flipdish-White-Label-Id': appId,
      'X-Flipdish-Token': Cookies?.get('flipdish-token') || '',
      'Suppress-Auth-Cookie': 'true',
    };

    const response = await fetch(
      `${baseUrl}/map/DeliveryLocationForms?deviceId=${deviceId}&language=${lang}`,
      {
        method: 'GET',
        headers,
      },
    );
    return await response.json();
  } catch (e: any) {
    logger.error(`getDeliveryAddresses for ${appId || 'undefined'}`, {
      message: e.message,
    });
    console.log('error', e);
    throw e;
  }
};

export { getDeliveryAddresses };
